'use client';
import { RouterOutputs } from '@streetferret/api-client/client';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@streetferret/ui-web/card';
import { Separator } from '@streetferret/ui-web/separator';
import { Skeleton } from '@streetferret/ui-web/skeleton';
import { format } from 'date-fns';
import { BarsList } from '../_components/bars-list';
interface MileageBreakdown_implProps {
  children: React.ReactNode;
}
export function MileageBreakdown_impl({
  children,
}: MileageBreakdown_implProps) {
  return (
    <Card className="not-prose">
      <CardHeader>
        <CardTitle>Daily Mileage</CardTitle>
        <CardDescription>Mileage covered each day</CardDescription>
      </CardHeader>
      <Separator />
      <div className="not-prose">{children}</div>
    </Card>
  );
}

interface MileageBreakdownBarsProps {
  data: RouterOutputs['journey']['widgets']['dailyMileage'] | undefined;
}
export function MileageBreakdownBars({ data }: MileageBreakdownBarsProps) {
  const dailyMileage = data ? data : [];
  const max =
    dailyMileage?.reduce((acc, curr) => Math.max(curr.distance, acc), 0) ?? 0;
  return (
    <BarsList
      activityType="run"
      title="Daily Mileage"
      total={max}
      unit="mi"
      data={dailyMileage.map(mileage => {
        return {
          title: `Day ${mileage.day} - ${format(
            mileage.date ?? new Date(),
            'MMM d',
          )}`,
          value: mileage.distance,
        };
      })}
    />
  );
}

const PLACEHOLDER_BAR_VALUES = [86, 95, 71, 82, 87, 90, 75, 92, 80, 90];
/**
 * Empty state for when journey data is missing.
 */
export function MileageBreakdownBarsError() {
  return (
    <div className="relative">
      <div className="grid absolute inset-0 place-content-center">
        <div className="text-muted-foreground text-lg pb-6">
          Journey has not started yet
        </div>
      </div>
      <div className="grid gap-2 pt-4">
        {PLACEHOLDER_BAR_VALUES.map((value, idx) => (
          <div
            key={idx}
            className="h-8 bg-muted/40 rounded-md"
            style={{ width: `${value}%` }}
          />
        ))}
      </div>
    </div>
  );
}

const LOADING_BAR_COUNT = PLACEHOLDER_BAR_VALUES.length;
export function MileageBreakdownBarsSkeleton() {
  return (
    <div className="grid gap-2 pt-4">
      {Array.from({ length: LOADING_BAR_COUNT }).map((_, idx) => (
        <Skeleton key={idx} className="h-8 w-full" />
      ))}
    </div>
  );
}
